import { useEffect, useRef, useState } from "react";
import { Singleton } from "../../../../../../core/services/Singleton";
import { BasicTable, MASK_BOOLEAN, MASK_MONEY, MASK_NUMBER } from "../../../../../theme/Component/BasicTable";
import { ListMenu } from "../../../../../theme/Component/ListMenu";
import { Modal } from "../../../../../theme/Component/Modal";
import useDataBean from "../../../../../../core/services/dataBean/useDataBean";
import { _single, _UBLInvoice, _UBLItemInvoice } from "../../../../../../core/services/dataBean/EntityCatalog";
import { TaxSchemeValueRadioSelectorByUBLItemInvoice } from "./TaxSchemeValueRadioSelectorByUBLItemInvoice";
import { toast } from "react-toastify";
import { EDITOR_ARTICLE } from "../../../../../editor/Editors";
import { ModalConfirm } from "../../../../../theme/Component/ModalConfirm";
import { DropDown } from "../../../../../theme/Component/DropDown";
import { CashReimbursementConceptEditor } from "../../../../../Talentohumano/CajasMenoresConceptos/CashReimbursementConcept.editor";
import { BasicButton } from "../../../../../theme/Component/BasicButton";
import { InputMoney } from "../../../../../theme/Input/InputMoney";
import { SelectProductEditor } from "../../../../../Factoty&Production/ManufacturingStandars/Components/SelectProductEditor";
import { SelectorUmeasurement } from "../../../../../bpm/config/Componentes/SelectorUmeasurement";
import useModal, { MODAL_LG, MODAL_md } from "../../../../../theme/Component/hooks/useModal";
import { ImportXLSX } from "../../../../../theme/Component/ImportXLSX";
import { UBLInvoiceTaxSupplier } from "../../UBLInvoiceSupplier/Component/UBLInvoiceTax/UBLInvoiceTaxSupplier";
import { AssetClassfierEditor } from "../../../../../editor/AssetClassifier/AssetClassfierEditor";
import { Alert } from "../../../../../theme/Component/Alert";
import { MeasurementUnitCodeEditor } from "../../../../../erp/MeasurementUnitCode/MeasurementUnitCode.editor";
import { SelectUBLItemValue } from "./ComponentPrepaidPayment/SelectUBLItemValue";
import { TaxableArticleTypesEditor } from "../../../../../admin/ConfImpuestos/TaxScheme/FuncionesTaxScheme/TaxableArticleTypes.editor";
import { BasicSwitch } from "../../../../../theme/Component/BasicSwitch";
import { SelectBusinessCore } from "../../../../../erp/cellEditor/BusinessCore/SelectBusinessCore";
import { SelectProject } from "../../../../../erp/cellEditor/BudgetAccountantOperation/SelectProject";
import { SelectAccountantTree } from "../../../../../contabilidad/catalogo-cuentas/AccountantTree/SelectAccountantTree";
import { OBsBudgetEditor } from "../../UBLInvoiceSupplier/Component/UBLInoviceItemSupplier/Component/OBsBudgetEditor";
import { OBsEditor } from "../../UBLInvoiceSupplier/Component/OBsEditor";
import { CostingCenterEditor } from "../../UBLInvoiceSupplier/CostingCenterEditor";
import { _Updateschema } from "../../../../../../core/services/dataBean/EntityCatalogVdos";
import { UBLPaymentMeansEditor } from "../../../../../Inventories-Warehouses/Product/UBLPaymentMeans/UBLPaymentMeansEditor";
import { UBLPaymentMeansCodeEditor } from "../../../../../Inventories-Warehouses/Product/UBLPaymentMeansCode/UBLPaymentMeansCodeEditor";
import { EditorUBLAdminFee } from "../../UBLAdminFee/EditorUBLAdminFee";
import { PrintJson } from "../../../../../theme/Component/PrintJson";


interface Props {
    idUBLInvoice: number;
    issueDate: Date;
    _onChange?: Function;
    _data?: any;
    updateFunction?: Function;
    _isAlmacen?: boolean;
}

const PURCHASE_INVOICE = 0;
const BILL_OF_SALE = 1;
const NoteDeb = 2;
const NoteCre = 3;

export const CreateUBLInvoiceItems = ({ idUBLInvoice, issueDate, _data, _onChange, updateFunction, _isAlmacen }: Props) => {

    const single = Singleton.getInstance();
    const { instance, lista, setLista, bean, setBean, handleChange } = useDataBean(_UBLItemInvoice);
    const _ublInvoice = useDataBean(_UBLInvoice)
    const updateschema = useDataBean(_Updateschema);
    const [missingFields, setMissingFields] = useState<string[]>([]);
    const [taxApply, setTaxApply] = useState<any>([]);
    const [idConceptReimbursement, setIDConceptReimbursement] = useState<number>(NaN);
    const [invoice, setInvoice] = useState<any>({});
    const [observaciones, setObservaciones] = useState<string>("");
    const [errorList, setErrorList] = useState<any>([])
    const modifiAnyWay = _single.getSessionItem("canModifiUBL") ? JSON.parse(_single.getSessionItem("canModifiUBL")) : false;


    const [modalclf, setModalclf] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalImpuestos, setModalImpuestos] = useState<any>({ name: 'Ver Impuestos', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalAddUBLReimbursment, setModalAddUBLReimbursment] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalReleaseUBLReimbursment, setModalReleaseUBLReimbursment] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const [modalValidateAccounting, setModalValidateAccounting] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalErrorList, setModalErrorList] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalSend, setModalSend] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalRetenciones, setModalRetenciones] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: false, format: 'modal-lg' });
    const [modalAjust, setModalAjust] = useState<any>({ name: "Ajuste Contable", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const [modalType, setModalType] = useState<any>({ name: "Modificar Tipo de Articulo", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const modalEdit = useModal(`Modificar item de factura ${bean.Name}`, MODAL_LG);
    const modalCostingCenter = useModal("Centro de costo", MODAL_md);
    const modalAssets = useModal("Clasificación", MODAL_LG);
    const modalSetAIU = useModal("Definir Tipos de AIU", MODAL_LG);


    const assetClassfierRef = useRef<any>(null);

    useEffect(() => {
        if (!idUBLInvoice) {
            toast.error("Error alcargar la factura")
        } else if (!issueDate) {
            toast.error("Error alcargar la factura")
        } else {
            getLista();
            getInvoice();
        }
    }, [idUBLInvoice])

    useEffect(() => {
        if (lista.length > 0) {
            const fieldsMissing = lista.reduce((acc, objeto) => {
                if (!objeto.DataBeanProperties.IDFixedAsset && !objeto.DataBeanProperties.IDProduct) {
                    acc.push({
                        IDUBLItemInvoice: objeto.DataBeanProperties.IDUBLItemInvoice,
                        Description: objeto.DataBeanProperties.Description
                    });
                }
                return acc;
            }, []);

            setMissingFields(fieldsMissing);
        }
    }, [lista]);


    //servicios Basicos UBLInvoiceItem

    const getLista = () => {
        instance.getUBLItemInvoiceCatalog(idUBLInvoice, issueDate).then(
            (resp) => {

                let tmp = resp;
                tmp.forEach((element: any) => {
                    element.DataBeanProperties.Orden = _data ?? {};
                    element.DataBeanProperties.BudgetName = element.DataBeanProperties.BudgetJsconCode + " " + element.DataBeanProperties.BudgetName;
                });
                setLista(tmp)
            }
        )
    }

    const getInvoice = () => {
        _ublInvoice.instance.getUblInvoice(idUBLInvoice, issueDate).then(
            (resp) => {
                setInvoice(resp)
            }
        ).catch(
            err => {
                toast.error(err)
            }
        )
    }

    const create = () => {
        setBean({
            IDUBLInvoice: idUBLInvoice,
            IssueDate: issueDate,
            AssetType: invoice.UBLDocumentType === 1 ? 6 : null
        })
        setModal({ ...modal, "view": true, "name": "Crear Item de Factura" })
    }

    const updateTaxItem = () => {
        instance.parseTaxSchemaValuesForUBLInvoiceItem(bean.IDUBLItemInvoice, issueDate, taxApply).then(
            (resp) => {
                setModalImpuestos({ ...modalImpuestos, "view": false });
                getLista();
            }
        )
    }
    const updateTaxSchemaValuesForUBLInvoice = () => {

        updateschema.instance.updateTaxSchemaValuesForUBLInvoice(bean.IDUBLInvoice, bean.IssueDate).then(
            (resp: any) => {

                toast.success("Se realizo la Acción");
                getLista()
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const createItemSales = () => {
        console.log(idUBLInvoice, issueDate, bean.IDProduct, bean.Quantity, bean.UnitaryValue, bean.Description, bean.MeasurementUnitCode)
        instance.createProductRowForUBLSalesInvoice(idUBLInvoice, issueDate, bean.IDProduct, bean.Quantity, bean.UnitaryValue, bean.Description, bean.MeasurementUnitCode, bean.AdquisitionArticleType).then(
            (resp) => {
                console.log(resp)
                getLista();
                if (_onChange) {
                    _onChange();
                }
                setModal({ ...modal, "view": false })
            }
        ).catch(
            err => {
                console.log(err);
                toast.error("Error al crear el item")
            }
        )
    }

    const createItemPurchase = () => {
        instance.createProductRowForUBLPurchaseInvoice(idUBLInvoice, issueDate, bean.Quantity, bean.Description, bean.TotalItemAmount, bean.MeasurementUnitCode, bean.AdquisitionArticleType).then(
            (resp) => {
                console.log(resp)
                getLista();
                if (_onChange) {
                    _onChange();
                }
                setModal({ ...modal, "view": false })
            }
        ).catch(
            err => {
                console.log(err);
                toast.error("Error al crear el item")
            }
        )
    }

    const delteItem = () => {
        instance.deleteUBLItemInvoice(bean.IssueDate, bean.IDUBLItemInvoice).then(
            (resp) => {
                getLista();
                setModalC({ ...modalC, "view": false });

            }
        )
    }

    const validateData = () => {
        if (validateForm() > 0) {
            toast.error("Faltan campos obligatorios por completar");
            return;
        } else {
            // console.log(invoice.UBLDocumentType === 1 || invoice.UBLDocumentType === 2 || invoice.UBLDocumentType === 3)
            if (invoice.UBLDocumentType === 1 || invoice.UBLDocumentType === 2 || invoice.UBLDocumentType === 3) {
                createItemSales();
            } else {
                createItemPurchase();
            }
        }
    }

    const validateForm = () => {
        const requiredFields = [
        ];
        // "Description", "MeasurementUnitCode", "Quantity", "TotalItemAmount", "IDLnSiteID",
        let missing = [];
        for (let field of requiredFields) {
            if (bean[field] === null || bean[field] === undefined || bean[field] === "") {
                missing.push(field);
            }
        }
        setMissingFields(missing);
        return missing.length
    };


    //fin Servicios UBLInvoiceItem Contrac

    //Inicio Servicios UBLInvoiceItem Cajas Menores
    const addUBLInvoiceItemToReimbusrment = () => {
        instance.addUBLItemInvoiceToCashReimbursementConcept(_data.CashReimbursementDate, _data.IDCashReimbursementItem, bean.IDUBLItemInvoice, idConceptReimbursement).then(
            (resp) => {
                getLista();
                setModalAddUBLReimbursment({ ...modalAddUBLReimbursment, "view": false })
            }
        ).catch(
            err => {
                toast.error(err)
            }
        )
    }

    const deleteUBLInvoiceItemToReimbusrment = () => {
        instance.releaseUBLItemInvoiceToCashReimbursementConcept(_data.CashReimbursementDate, _data.IDCashReimbursementItem, bean.IDUBLItemInvoice).then(
            (resp) => {
                getLista();
                setModalReleaseUBLReimbursment({ ...modalReleaseUBLReimbursment, "view": false })
            }
        ).catch(
            err => {
                toast.error(err)
            }
        )
    }
    //Fin Servicios UBLInvoiceItem Cajas Menores

    // const head = [
    //     { title: 'ID', property: 'IDUBLItemInvoice', visible: true ,mask:MASK_NUMBER},
    //     // { title: 'Tipo de Bien/Servicio', property: 'AdquisitionArticleTypeName', visible: true },
    //     { title: 'Nombre del Bien o Servicio', property: 'Description', visible: true },
    //     { title: 'Unidades', property: 'MeasurementUnitCodeName', visible: false },
    //     { title: 'Valor Unitario', property: 'UnitaryValue', visible: true, mask: MASK_MONEY },
    //     { title: 'Cantidad', property: 'Quantity', visible: true },
    //     { title: 'Subtotal', property: 'TaxableAmount', visible: true, mask: MASK_MONEY },
    //     { title: 'Subtotal Impuestos', property: 'TaxAmount', visible: true, mask: MASK_MONEY },
    //     { title: 'Valor Total', property: 'TotalItemAmount', visible: true, mask: MASK_MONEY },
    //     { title: 'Ciudad de Bien/Servicio', property: 'SiteIDName', visible: false },
    //     { title: 'Cuenta Contable', property: 'AccountantIDName', visible: false },
    //     { title: 'Rubro Presupuestal', property: 'BudgetName', visible: false },
    //     { title: 'Tipo de Bien', property: 'AssetTypeName', visible: true },
    //     { title: 'Artículo', property: 'IDAdquisitionArticle', visible: (_data?.IDSupplierPaymentOrder ? true : false && (invoice.ProcessType === 7)), cellEditor: _data ? EDITOR_ARTICLE : undefined },
    //     { title: 'Rembolso', property: 'IDCashReimbursementConcept', visible: (_data?.IDCashReimbursementItem ? true : false) },
    // ]
    const head = [
        { title: 'ID', property: 'IDUBLItemInvoice', visible: false },
        { title: 'Nombre del Bien o Servicio', property: 'Description', visible: true },
        { title: 'Modelo de gestión Centro de Costo', property: 'CostingCenterMethodName', visible: true },
        { title: 'Centro de Costo', property: 'CostingCenterName', visible: bean.CostingCenterMethod === 2 },
        { title: 'Valor Unitario', property: 'UnitaryValue', visible: true, mask: MASK_MONEY },
        { title: 'Cantidad', property: 'Quantity', visible: true },
        { title: 'Subtotal', property: 'TaxableAmount', visible: true, mask: MASK_MONEY },
        { title: 'Subtotal Impuestos', property: 'TaxAmount', visible: true, mask: MASK_MONEY },
        { title: 'Impuestos de Valor Agregado Mayor Valor del Costo', property: 'AddedTaxHigherValue', visible: true, mask: MASK_BOOLEAN },
        { title: 'Valor Total', property: 'TotalItemAmount', visible: true, mask: MASK_MONEY },
        { title: 'Tipo de Artículo', property: 'AdquisitionArticleTypeName', visible: true },
        { title: 'Clasificación Almacén', property: 'AssetTypeName', visible: true },
        { title: 'Ciudad de Bien/Servicio', property: 'SiteIDName', visible: false },
        { title: 'Obligación', property: 'OBName', visible: true },
        { title: 'Cuenta Contable', property: 'AccountantIDName', visible: true },
        { title: 'Rubro Presupuestal', property: 'BudgetName', visible: true },
        { title: 'Tipo de Bien', property: 'AssetTypeName', visible: false },
        { title: 'Producto/Activo Asociado', property: "ProductDescription", visible: true },
        { title: 'Es AIU', property: "UseAdminFee", visible: true },
        { title: 'Vr Distribución AIU', property: "AdminFeeValue", visible: true },
        { title: 'Clase de AIU', property: "IDUBLAdminFee", visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Actualizar Cálculo de Impuestos', visible: single.canCreate(), icono: 'ri-arrow-go-forward-fill', evento: updateTaxSchemaValuesForUBLInvoice },
        { nombre: 'Agregar', visible: modifiAnyWay == true || (invoice.SourceType === 7 && (!invoice.ProcessType) && (!_data?.IDSupplierPaymentOrder) && (!_data?.IDCashReimbursementItem)), icono: 'ri-file-add-line', evento: () => { create() } },
        { nombre: 'Importar', visible: (invoice.SourceType === 7 && (!invoice.ProcessType) && (!_data?.IDSupplierPaymentOrder) && (!_data?.IDCashReimbursementItem) && !(invoice.UBLDocumentType === 1)), icono: 'ri-file-excel-line', evento: () => { modalImport.open(); } }
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Modificar tipo de Articulo', icono: 'ri-edit-line', visible: true, evento: () => { setModalType({ ...modalType, "view": true }) } },
            { titulo: 'Clasifica Activos/Productos', icono: 'ri-file-list-2-line', visible: true, evento: () => { setModalclf({ ...modalclf, "view": true, "name": "Clasificar Activos y Productos" }) } },
            { titulo: 'Defirnir Tipo de AIU', icono: 'ri-file-list-2-line', visible: true, evento: () => { modalSetAIU.open() } },
            { titulo: 'Ajuste Contable', icono: 'ri-file-list-2-line', visible: true, evento: () => { setModalAjust({ ...modalAjust, "view": true }) } },
            { titulo: 'Agregar/Eliminar Impuestos', icono: 'ri-file-list-2-line', visible: modifiAnyWay || (invoice.SourceType === 7 && (!_data?.IDSupplierPaymentOrder) && (!_data?.IDCashReimbursementItem)), evento: () => { setModalImpuestos({ ...modalImpuestos, "view": true }) } },
            { titulo: 'Editar Item de la Factura', icono: 'ri-edit-line', visible: (single.canEdit && (!invoice.ProcessType) && (!_data?.IDSupplierPaymentOrder) && (!_data?.IDCashReimbursementItem)), evento: () => { modalEdit.open() } },
            { titulo: 'Definir Centro de Costo', icono: 'ri-file-list-2-line', visible: bean.RequiresCostingCenter, evento: () => { modalCostingCenter.open() } },
            { titulo: 'Clasifica Activos/Productos', icono: 'ri-file-list-2-line', visible: (_isAlmacen ? _isAlmacen : false), evento: () => { modalAssets.open() } },
            { titulo: 'Eliminar Item de la Factura', icono: 'ri-delete-bin-2-line', visible: modifiAnyWay || (invoice.SourceType === 7 && (!invoice.ProcessType) && (!_data?.IDSupplierPaymentOrder) && (!_data?.IDCashReimbursementItem)), evento: () => { setModalC({ ...modalC, "name": `Eliminar Item ${bean.Description}`, "view": true }) } },
            { titulo: 'Definir Concepto de Causación', icono: 'ri-file-add-line', visible: (_data?.IDCashReimbursementItem), evento: () => { setModalAddUBLReimbursment({ ...modalAddUBLReimbursment, "name": `Definir Concepto de Causación`, "view": true }) } },
            { titulo: 'Eliminar Concepto de Causación', icono: 'ri-file-reduce-line', visible: (_data?.IDCashReimbursementItem), evento: () => { setModalReleaseUBLReimbursment({ ...modalReleaseUBLReimbursment, "name": `Eliminar Concepto de Causación`, "view": true }) } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const validateInvoice = () => {
        _ublInvoice.instance.requestUBLInvoiceToAccounting(idUBLInvoice, issueDate, single.getAccountID(), observaciones).then(
            (resp) => {
                if (resp.ErrorList.length == 0) {
                    toast.success("Factura correcta");
                    setModalSend({ ...modalSend, "view": true, "name": "Definir envio" })
                } else {
                    setErrorList(resp.ErrorList)
                    setModalErrorList({ ...modalErrorList, "view": true, "name": "Se encontraron las siguientes incidencias con la factura" });
                    toast.warning("Factura con problemas");
                }

                setModalValidateAccounting({ ...modalValidateAccounting, "view": false });
            }
        ).catch(
            err => {
                toast.error(err, { autoClose: false });
            }
        )
    }

    const actionsDropDown = [
        { id: 1, name: 'Validar Contabilización', permiso: null, activo: true },
    ];

    const eventChange = (e: any) => {
        if (e.id === 1) {
            setModalValidateAccounting({ ...modalValidateAccounting, "name": `Validar Contabilización`, "view": true })
        }
    }

    const buttons = () => {
        if (_data?.IDCashReimbursementItem) {
            return (
                <div className="row">
                    <div className="col-md-12">
                        <DropDown lista={actionsDropDown} eventClick={eventChange}></DropDown>
                    </div>
                </div>
            )
        }
    }

    const sendToAccounting = () => {
        instance.sendCashReimbursementItemToAccounting(_data.IDCashReimbursementItem, _data.CashReimbursementDate, "", single.getAccountID()).then(
            (resp) => {
                toast.success("Accion realizada");
                setModalSend({ ...modalSend, "view": false })
                if (updateFunction) {
                    updateFunction();
                }
            }
        ).catch(
            err => {
                console.error(err);
                toast.error(err, { autoClose: false })
            }
        )
    }

    const setAdminFee = () => {
        if (bean.UseAdminFee && !bean.IDUBLAdminFee) {
            toast.error("Los Campos son obligatorios");
            return;
        }
        instance.setAdminFeeToUBLItemInvoice(bean.IDUBLItemInvoice, bean.IssueDate, bean.UseAdminFee, bean.IDUBLAdminFee).then(
            (resp) => {
                getLista();
                modalSetAIU.close();
            }
        ).catch(
            err => {
                console.error(err);
                toast.error(err, { autoClose: false })
            }
        )
    }

    const sendToStore = () => {
        instance.sendCashReimbursementItemToStore(_data.IDCashReimbursementItem, _data.CashReimbursementDate, "", single.getAccountID()).then(
            (resp) => {
                toast.success("Accion realizada");
                setModalSend({ ...modalSend, "view": false })
                if (updateFunction) {
                    updateFunction();
                }
            }
        ).catch(
            err => {
                console.error(err);
                toast.error(err, { autoClose: false })
            }
        )
    }


    const modalImport = useModal("Importar", MODAL_md);
    const [listImport, setListImport] = useState([]);

    const importMenu = async () => {
        console.log(listImport);
        let existe: string[] = [];
        let errores: number[] = [];

        lista.forEach(element => {
            existe.push(element.DataBeanProperties.Description.trim());
        });

        for (let index = 1; index < listImport.length; index++) {
            let row = listImport[index];

            if (!existe.includes(row[1])) {
                let obj = {
                    Quantity: row[3],
                    Description: row[1],
                    MeasurementUnitCode: row[2],
                    TotalValue: row[4],
                    AdquisitionArticleType: row[5]
                };

                try {
                    await instance.createProductRowForUBLPurchaseInvoice(
                        idUBLInvoice,
                        issueDate,
                        obj.Quantity,
                        obj.Description,
                        obj.TotalValue,
                        obj.MeasurementUnitCode,
                        obj.AdquisitionArticleType
                    ).then(
                        (resp) => {
                            toast.success(`Item creado en la fila ${index + 1}`)
                        }
                    )
                } catch (err) {
                    console.log(`Error en la fila ${index}:`, err);
                    toast.error(`Error al crear el item en la fila ${index}`);
                    errores.push(index);
                }
            }
        }

        // fin del proceso

        await getLista();

        if (_onChange) {
            _onChange();
        }

        setModal({ ...modal, "view": false });

        modalImport.close();

        if (errores.length > 0) {
            alert(`Error en los siguientes índices: ${errores.join(", ")}`);
        }
    };


    const updateItem = () => {
        instance.updateUBLItemInvoice(bean).then(
            (resp) => {
                getLista();
                setModal({ ...modal, "view": false });
                setModalAjust({ ...modalAjust, "view": false });
                setModalType({ ...modalType, view: false });
                modalEdit.close();
                modalCostingCenter.close();
            }
        ).catch(
            err => {
                console.log(err)
            }
        )
    }

    const updateItemAssets = () => {
        if (assetClassfierRef.current) {
            const { typeClass } = assetClassfierRef.current;
            const isValid = assetClassfierRef.current.validateData();
            //console.log(assetClassfierRef.current.validateData())

            if (typeClass == 5) {
                if (isValid) {
                    let x = assetClassfierRef.current.updateObject();
                    //console.log(x);
                    instance.updateUBLItemInvoice(x).then(
                        (resp) => {
                            getLista();
                            modalAssets.close();
                        }
                    ).catch(
                        err => {
                            console.error(err);
                            toast.error("No Se Pudo Realizar la Acción", {})
                        }
                    )
                } else {
                    toast.error("Debe crear primero el objeto", {})
                }
            } else {
                instance.updateUBLItemInvoice(bean).then(
                    (resp) => {
                        getLista();
                        modalAssets.close();
                    }
                ).catch(
                    err => {
                        console.error(err);
                        toast.error("No Se Pudo Realizar la Accion")
                    }
                )
            }

        } else {
            instance.updateUBLItemInvoice(bean).then(
                (resp) => {
                    getLista();
                    modalAssets.close();
                }
            ).catch(
                err => {
                    console.error(err);
                    toast.error("No Se Pudo Realizar la Accion", {})
                }
            )
        }
    }

    const updateCostingCenter = (e: any) => {
        let temp = { ...bean, ...e };
        setBean(temp);
    }

    return (
        <>
            <div className="row">
                <div className="col-md-6">
                    <strong>Proveedor </strong><small>{invoice.AccountSupplierName}</small>
                </div>
                <div className="col-md-6">
                    <strong>Idenficación </strong><small>{invoice.AccountSupplierNit}</small>
                </div>
                <div className="col-md-6">
                    <strong>Valor </strong><small>{_single.formatMoney(invoice.TotalInvoiceAmount)}</small>
                </div>
                <div className="col-md-6">
                    <strong>Concepto </strong><small>{invoice.AccountantConceptName}</small>
                </div>
                <div className="col-md-6">
                    <strong>Proceso </strong><small>{invoice.ProcessTypeName}</small>
                </div>
                <div className="col-md-6">
                    <strong>ID Factura </strong><small>{invoice.IDUBLInvoice}</small>
                </div>
                <div className="col-md-6">
                    <strong>Fecha Factura </strong><small>{invoice.IssueDate}</small>
                </div>
                <div className="col-md-12">
                    {missingFields.length > 0 &&
                        <Alert clase="warning">

                            <strong>Bien/Servicio sin gestion de Producto/Activo Asociado:</strong> <small>{missingFields.length}</small>
                        </Alert>

                    }
                </div>
            </div>
            {(invoice.ProcessType === 7 && _data) ?
                <div className="row">
                    <div className="col-md-12">
                        <BasicTable iconButtons={iconButtonsItem} listButtons={listaBotones()} body={lista} head={head} rowSet={setBean} callBack={getLista} />
                    </div>
                </div>
                :
                <>
                    <div className="row">
                        {/* Tabla de InvoiceItems rembolso-normal */}
                        <div className="col-md-12">
                            <BasicTable iconButtons={iconButtonsItem} headButtons={buttons()} listButtons={listaBotones()} body={lista} head={head} rowSet={setBean} />
                        </div>
                        {/* <div className="col-md-12">
                            <BasicButton eventClick={() => { setModalRetenciones({ ...modalRetenciones, "view": true }) }} icon="ri-save-line" children={"Impuestos de la Factura"} />
                        </div> */}
                    </div>
                </>
            }

            {/* Modales basicos de UBLInvoice Items */}
            {modal.view &&
                <Modal modal={modal} updateModal={setModal} eventModal={
                    () => {
                        if (bean.IDUBLItemInvoice) {
                            updateItem()
                        } else {
                            validateData()
                        }
                    }
                } >
                    {(invoice.UBLDocumentType === 1 || invoice.UBLDocumentType === 2 || invoice.UBLDocumentType === 3) &&
                        <div className="row">
                            <div className="col-md-12">
                                <SelectProductEditor renderValue={bean.ProductDescription} onChange={(e) => { setBean({ ...bean, "IDProduct": e.IDProduct, "Description": e.Description, "MeasurementUnitCode": e.IDMeasurementUnit, "UnitaryValue": e.SalesValue }) }} label="Producto de Venta" />
                            </div>
                            <div className="col-12">
                                <label className={`${missingFields.includes('UnitaryValue') ? 'has-error' : ''}`}>Costo Unitario</label>
                                <SelectUBLItemValue idProduct={bean.IDProduct} idSelector={bean.UnitaryValue} onChange={(e) => { setBean({ ...bean, "UnitaryValue": e }) }} />
                                {/* <InputMoney _label=" " _value={bean.UnitaryValue} onChange={(e) => { setBean({ ...bean, "UnitaryValue": e }) }} /> */}
                            </div>
                            <div className="col-12">
                                <label className={`${missingFields.includes('Quantity') ? 'has-error' : ''}`}>Cantidad</label>
                                <input disabled={!(modifiAnyWay || invoice.SourceType === 7)} type="number" name="Quantity" className="form-control" value={bean.Quantity} onChange={handleChange} />
                            </div>
                            <div className="col-12">
                                <label className={`${missingFields.includes('Description') ? 'has-error' : ''}`}>Nombre del Bien o Servicio</label>
                                <input type="text" disabled={!(modifiAnyWay || invoice.SourceType === 7)} name="Description" className="form-control" value={bean.Description} onChange={handleChange} />
                            </div>
                            <div className="col-12">
                                <label className={`${missingFields.includes('MeasurementUnitCode') ? 'has-error' : ''}`}>Unidades</label>
                                <MeasurementUnitCodeEditor label=' ' idSelector={bean.MeasurementUnitCode} onChange={(e) => { setBean({ ...bean, "MeasurementUnitCode": e }) }} />
                            </div>
                            <div className="col-md-12">
                                <label className={`${missingFields.includes('AdquisitionArticleType') ? 'has-error' : ''}`}>Tipo de Articulo</label>
                                <TaxableArticleTypesEditor label=" " idSelector={bean.AdquisitionArticleType} onChange={(e) => setBean({ ...bean, "AdquisitionArticleType": e })} />
                            </div>
                        </div>
                    }
                    {invoice.UBLDocumentType === 0 &&
                        <div className="row">
                            <div className="col-12">
                                <label className={`${missingFields.includes('Quantity') ? 'has-error' : ''}`}>Cantidad</label>
                                <input disabled={!(modifiAnyWay || invoice.SourceType === 7)} type="number" name="Quantity" className="form-control" value={bean.Quantity} onChange={handleChange} />
                            </div>
                            <div className="col-12">
                                <label className={`${missingFields.includes('Description') ? 'has-error' : ''}`}>Nombre del Bien o Servicio</label>
                                <input type="text" disabled={!(modifiAnyWay || invoice.SourceType === 7)} name="Description" className="form-control" value={bean.Description} onChange={handleChange} />
                            </div>
                            <div className="col-12">
                                <label className={`${missingFields.includes('TotalItemAmount') ? 'has-error' : ''}`}>Valor Total</label>
                                <InputMoney _label=" " readonly={!(modifiAnyWay || invoice.SourceType === 7)} _value={bean.TotalItemAmount} onChange={(e: any) => { setBean({ ...bean, 'TotalItemAmount': e }) }} />
                            </div>
                            <div className="col-12">
                                <label className={`${missingFields.includes('MeasurementUnitCode') ? 'has-error' : ''}`}>Unidades</label>
                                <MeasurementUnitCodeEditor label=' ' idSelector={bean.MeasurementUnitCode} onChange={(e) => { setBean({ ...bean, "MeasurementUnitCode": e }) }} />
                            </div>
                            <div className="col-md-12">
                                <label className={`${missingFields.includes('AdquisitionArticleType') ? 'has-error' : ''}`}>Tipo de Articulo</label>
                                <TaxableArticleTypesEditor idSelector={bean.AdquisitionArticleType} onChange={(e) => setBean({ ...bean, "AdquisitionArticleType": e })} />
                            </div>
                        </div>
                    }
                </Modal>
            }
            <Modal modal={modalclf} updateModal={setModalclf}>
                <AssetClassfierEditor ref={assetClassfierRef} _itemInvoice={bean} />
            </Modal>
            <Modal modal={modalImport.modal} updateModal={modalImport.setModal} eventModal={importMenu} onSubmitLabel="Importar">
                <div className="row">
                    <div className="col">
                        <ImportXLSX lodaData={setListImport} />
                    </div>
                </div>
            </Modal>

            <Modal modal={modalType} updateModal={setModalType} eventModal={updateItem}>
                <div className="row">
                    <div className="col">
                        <TaxableArticleTypesEditor idSelector={bean.AdquisitionArticleType} onChange={(e) => setBean({ ...bean, "AdquisitionArticleType": e })} />
                    </div>
                </div>
            </Modal>


            <Modal modal={modalSetAIU.modal} updateModal={modalSetAIU.setModal} eventModal={setAdminFee}>
                <div className="row">
                    <div className="col-md-12">
                        <BasicSwitch estado={bean.UseAdminFee} eventChange={(e) => { setBean({ ...bean, UseAdminFee: e }) }} label="Es AIU" />
                    </div>
                    <div className="col-md-12">
                        <EditorUBLAdminFee label="Clase de AIU" idSelector={bean.IDUBLAdminFee} onChange={(e) => { setBean({ ...bean, IDUBLAdminFee: e.IDUBLAdminFee }) }} />
                    </div>
                </div>
            </Modal>

            <Modal modal={modalAssets.modal} updateModal={modalAssets.setModal} eventModal={updateItemAssets}>
                <AssetClassfierEditor ref={assetClassfierRef} _itemInvoice={bean} _onChange={(e) => { console.log(e) }} />
            </Modal>

            {modalC.view &&
                <ModalConfirm eventModal={delteItem} modal={modalC} updateModal={setModalC}>
                    <p>Eliminar Item</p>
                </ModalConfirm>
            }

            {(modalImpuestos.view && invoice.SourceType) &&
                <Modal modal={modalImpuestos} updateModal={setModalImpuestos} eventModal={() => { updateTaxItem() }} >
                    <div className="row">
                        <div className="col-12">
                            <TaxSchemeValueRadioSelectorByUBLItemInvoice _UBLinvsourceType={invoice.SourceType} idUBLItem={bean.IDUBLItemInvoice} issueDate={issueDate} onChange={(e) => { setTaxApply(e) }} />
                        </div>
                    </div>
                </Modal>
            }

            {modalAddUBLReimbursment.view &&
                <Modal modal={modalAddUBLReimbursment} updateModal={setModalAddUBLReimbursment} eventModal={() => { addUBLInvoiceItemToReimbusrment() }} >
                    <div className="row">
                        <div className="col-12">
                            <CashReimbursementConceptEditor idSelector={idConceptReimbursement} onChange={(e) => { setIDConceptReimbursement(e) }} label="Conceptos" />
                        </div>
                    </div>
                </Modal>
            }

            {modalReleaseUBLReimbursment.view &&
                <Modal modal={modalReleaseUBLReimbursment} updateModal={setModalReleaseUBLReimbursment} eventModal={() => { deleteUBLInvoiceItemToReimbusrment() }} >
                    <>
                        Esta seguro que desea Eliminar el concepto de Causación
                    </>
                </Modal>
            }

            {modalValidateAccounting.view &&
                <Modal modal={modalValidateAccounting} onSubmitLabel="Validar" updateModal={setModalValidateAccounting} eventModal={() => { validateInvoice() }} >
                    <p>
                        Confirme si desea continuar con la validacion de la factura para Contabilización
                    </p>
                </Modal>
            }

            {modalSend.view &&
                <Modal modal={modalSend} updateModal={setModalSend}  >
                    <div className="row">
                        <div className="col-12">
                            <label>Observaciones</label>
                            <textarea value={observaciones} rows={4} onChange={(e) => { setObservaciones(e.target.value) }} className="form-control" />
                        </div>
                        <div className="col-md-12">
                            <div className="d-flex justify-content-between p-2">
                                <BasicButton icon="" eventClick={sendToStore}>Enviarlo a Almacen</BasicButton>
                                <BasicButton icon="" eventClick={sendToAccounting}>Enviarlo a Contabilización</BasicButton>
                            </div>
                        </div>
                    </div>
                </Modal>
            }

            <div className="col-md-12">
                <Modal modal={modalRetenciones} updateModal={setModalRetenciones} >
                    <UBLInvoiceTaxSupplier idublInvoice={invoice.IDUBLInvoice} issueDate={invoice.IssueDate} />
                </Modal>
            </div>

            <div className="col-md-12">
                <Modal modal={modalEdit.modal} updateModal={modalEdit.setModal} eventModal={() => { updateItem() }} >
                    <div className="row">
                        {invoice.PaymentType === 17 &&
                            <>
                                <div className="col-md-6">
                                    <label className={`${missingFields.includes('OBIDDocument') ? 'has-error' : ''}`}>Obligación Presupuestal</label>
                                    <OBsEditor idDocument={bean.OBIDDocument} configProps={{ label: " " }} idAccount={invoice.IDAccountSupplier} paymentDate={invoice.AccountantDate}
                                        onChange={(e) => {
                                            console.log(e)
                                            setBean({
                                                ...bean,
                                                "OBIDDocument": e.IDDocument,
                                                "OBMnemonic": e.Mnemonic,
                                                "OBConsecutive": e.Consecutive,
                                                "OBDate": e.DocumentDate,
                                                "OBDocumentState": e.DocumentSate,
                                                "TotalItemAmount": bean.TotalItemAmount ?? e.OBValue,
                                                "Quantity": 1,
                                            })
                                        }} />
                                </div>
                                <div className="col-md-6">
                                    <label className={`${missingFields.includes('BudgetID') ? 'has-error' : ''}`}>Rubro Presupuestal</label>
                                    <OBsBudgetEditor renderValue={bean.BudgetName} _paymentDate={bean.OBDate} configProps={{ label: " " }} idDocument={bean.OBIDDocument} onChange={(e) => { setBean({ ...bean, "BudgetID": e.BudgetIDStr, "IDBudgetResource": e.IDBudgetResource, "IDBudgetSource": e.IDBudgetSource }) }} />
                                </div>
                            </>
                        }

                        <div className="col-md-6">
                            <UBLPaymentMeansEditor
                                render={bean.PaymentMeansID}
                                idSelector={bean.IDUBLPaymentMeans}
                                onChange={(e) =>
                                    setBean({
                                        ...bean,
                                        IDUBLPaymentMeans: e.IDUBLPaymentMeans,
                                        PaymentMeansID: e.Name
                                    })
                                }
                                returnType="Object"
                            />
                        </div>
                        <div className="col-md-6">
                            <UBLPaymentMeansCodeEditor
                                render={bean.PaymentMeansCode}
                                idSelector={bean.IDUBLPaymentMeansCode}
                                onChange={(e) =>
                                    setBean({
                                        ...bean,
                                        IDUBLPaymentMeansCode: e.IDUBLPaymentMeansCode,
                                        PaymentMeansCode: e.Name
                                    })
                                }
                                returnType="Object"
                            />
                        </div>

                        <div className="col-md-6">
                            <label className={`${missingFields.includes('Quantity') ? 'has-error' : ''}`}>Cantidad</label>
                            <input type="number" className="form-control" value={bean.Quantity} onChange={(e) => { setBean({ ...bean, "Quantity": e.target.value }) }} />
                        </div>
                        {/* <div className="col-md-6">
                                            <label className={`${missingFields.includes('BudgetID') ? 'has-error' : ''}`}>Rubro Presupuestal</label>
                                            <OBsBudgetEditor _paymentDate={invoice.OBDate} configProps={{ label: " " }} idDocument={invoice.OBIDDocument} onChange={(e) => { setBean({ ...bean, "BudgetID": e.BudgetIDStr, "IDBudgetResource": e.IDBudgetResource, "IDBudgetSource": e.IDBudgetSource }) }} />
                                        </div> */}
                        <div className="col-md-6">
                            <label className={`${missingFields.includes('TotalItemAmount') ? 'has-error' : ''}`}>Valor Total</label>
                            <InputMoney _value={bean.TotalItemAmount} onChange={(e) => { setBean({ ...bean, "TotalItemAmount": e }) }} _label=" " />
                        </div>
                        <div className="col-md-6">
                            <SelectProductEditor label="Producto" value={bean.IDProduct} onChange={(e) => { setBean({ ...bean, "IDProduct": e.IDProduct }) }} />
                        </div>
                        <div className="col-md-6">
                            <SelectorUmeasurement titulo='Unidad de Medida' idSelector={bean.IDMeasurementUnitCode} onChange={(e) => { setBean({ ...bean, "IDMeasurementUnitCode": e }) }} />
                        </div>
                        <div className="col-md-6">
                            <label className={`${missingFields.includes('AccountantID') ? 'has-error' : ''}`}>Cuenta Contable</label>
                            <SelectAccountantTree disabled={!bean.RequiresAccountantID} label=" " jsonCode={bean.AccountantID ?? invoice.AccountantIDStr} onChange={(e) => setBean({ ...bean, "AccountantID": e.JsonCode })} />
                        </div>

                        <div className="col-md-6">
                            <label className={`${missingFields.includes('IDProject') ? 'has-error' : ''}`}>Proyecto</label>
                            <SelectProject label=" " idSelector={bean.IDProject ?? invoice.IDProject} onChange={(e) => { setBean({ ...bean, "IDProject": e }) }} />
                        </div>
                        <div className="col-md-6">
                            <label className={`${missingFields.includes('IDBusinessCore') ? 'has-error' : ''}`}>Línea de Negocio</label>
                            <SelectBusinessCore returnType="ID" idSelector={bean.IDBusinessCore ?? invoice.IDBusinessCore} label=" " onChange={(e) => { setBean({ ...bean, "IDBusinessCore": e }) }} />
                        </div>

                        <div className="col-md-6">
                            <label className={`${missingFields.includes('AdquisitionArticleType') ? 'has-error' : ''}`}>Tipo de Articulo</label>
                            <TaxableArticleTypesEditor label=" " idSelector={bean.AdquisitionArticleType} onChange={(e) => setBean({ ...bean, "AdquisitionArticleType": e })} />
                        </div>

                        <div className="col-md-6">
                            <BasicSwitch label="Impuestos de Valor Agregado Mayor Valor del Costo " estado={(bean.AddedTaxHigherValue ?? false)} eventChange={(e) => { setBean({ ...bean, "AddedTaxHigherValue": e }) }} />
                        </div>
                        <div className="col-md-12">
                            <label className={`${missingFields.includes('Description') ? 'has-error' : ''}`}>Descripción</label>
                            <textarea className="form-control" value={bean.Description} onChange={(e) => { setBean({ ...bean, "Description": e.target.value }) }}></textarea>
                        </div>
                    </div>
                </Modal>
            </div>

            <div className="col-md-12">
                <Modal modal={modalAjust} updateModal={setModalAjust} eventModal={updateItem} >
                    <div className="col-12">
                        <label className={`${missingFields.includes('AccountingAdjustmentValue') ? 'has-error' : ''}`}>Ajuste Contable</label>
                        <input type="number" className="form-control" value={bean.AccountingAdjustmentValue} onChange={(e) => { setBean({ ...bean, "AccountingAdjustmentValue": e.target.value }) }} />
                    </div>
                </Modal>
            </div>


            {modalErrorList.view &&
                <Modal modal={modalErrorList} updateModal={setModalErrorList}  >
                    <div className="col-md-12">
                        <hr />
                        <ul className="list-group">
                            {
                                errorList.map((item: any, index: number) => {
                                    return (
                                        <li className="list-group-item">
                                            {index + 1} - {item}
                                        </li>
                                    )
                                })
                            }
                        </ul>
                    </div>
                </Modal>
            }

            <div className="col-md-12">
                <Modal modal={modalCostingCenter.modal} updateModal={modalCostingCenter.setModal} eventModal={updateItem}>
                    <CostingCenterEditor label="Centro de costo" idCostingCenterMethod={bean.CostingCenterMethod} costingCenterLabel={bean.CostingCenterMethodName} dataInput={bean} onChange={(e) => { updateCostingCenter(e) }} />
                </Modal>
            </div>


        </>
    )
}